module.exports = __webpack_public_path__ + "img/05-01_Developing myself.741e2b9f.svg";